import React from 'react';

export default function(props) {
    const datetime = new Date(props.datetime).toLocaleString('ru-RU', {
        year: '2-digit', 
        month: '2-digit', 
        day: '2-digit', 
        hour: '2-digit', 
        minute:'2-digit', 
        timeZone:'europe/moscow'})
    return <span>{datetime}</span>;
}
